import { useEffect } from "react";
import { startRingtone, type Ringtone } from "@shared/media";

/** Мелодия вызова, пока `on`: включилось — заиграла, выключилось или ушли — смолкла. */
export function useRingtone(kind: Ringtone, on: boolean) {
  useEffect(() => {
    if (!on) return;
    return startRingtone(kind);
  }, [kind, on]);
}
